import { TurboMount } from "turbo-mount"
import { registerComponent } from "turbo-mount/react"
import ProspectionApp from "../components/prospection/App"

const turboMount = new TurboMount()
registerComponent(turboMount, "ProspectionApp", ProspectionApp)
